export const params = {
    client_id: 'id-5e75518f-50b0-d798-cd87-47697def7a',
    client_secret: 'secret-cbec6aa7-d95c-a9f7-748d-3a0e6289e8b',
    grant_type:"client_credentials"
  };

export const appURL = "https://hydrobharat.gov.in/";

export const googleMapsApiKey = "AIzaSyARU2rr8X3qHbrz72oVswps5VMjldNFHW4";

export const navareaIndicator = "https://hydrobharat.gov.in/documents/d/asset-library-77782/orange-circle";
export const navtexIndicator = "https://hydrobharat.gov.in/documents/d/asset-library-77782/green-circle";
export const tnpIndicator = "https://hydrobharat.gov.in/documents/d/asset-library-77782/white-circle";
export const logo = "https://hydrobharat.gov.in/documents/d/guest/nho-png";

export const navareaLineOne = [
	{ lat: -10.500000, lng: 40.500000 },
	{ lat: -10.500000, lng: 55.000000 },
	{ lat: -30.000000, lng: 55.000000 },
	{ lat: -30.000000, lng: 95.000000 },
	{ lat: 6.000000, lng: 95.000000 },
	{ lat: 10.000000, lng: 98.500000 },
]

export const navareaLineTwo = [
	{ lat: 12.000000, lng: 51.000000 },
	{ lat: 12.000000, lng: 63.000000 },
	{ lat: 23.800000, lng: 68.083334 },
]


export const mapOptions = {
  mapTypeId: "hybrid",
  zoom: 3,
  center: { lat: -12.861277, lng: 86.359059 },
  minZoom: 2,

  restriction: {
    latLngBounds: {
      north: 84,
      south: -84,
      east: 179,
      west: -179,
    },
  },

  streetViewControl: false,
  gestureHandling: "cooperative",

  styles: [
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
  ],
};

function isFloat(n){
	if( Number(n) === n && n % 1 !== 0){
	return n;
	}else{
		return n+".00";
	}
}

// function getDMS2DD(degree, minutes, seconds)
// {	
// 	var dd = degree + (minutes/60) + (seconds/3600);
// 	return dd;
// }

// export function DDtoDMS(data)
// {
// 	var arr = data.split(',');
// 	var float_min_sec = parseFloat(arr[1]);

// 	var min_sec = isFloat(float_min_sec);
// 	min_sec = min_sec.toString();
// 	 var min_sec = min_sec.split('.');
	
// 	return getDMS2DD(parseInt(arr[0]), parseInt(min_sec[0]), parseInt(min_sec[1]));
// }

export function DDtoDMS(data) {
  if (!data) return null;
 
  // Clean the input
  let str = data.toString().trim().toUpperCase();
 
  // Detect hemisphere
  let hemiNegative = false;
  if (str.endsWith("S") || str.endsWith("W")) hemiNegative = true;
 
  // Remove hemisphere letters
  str = str.replace(/[NSEW]/g, "").trim();
 
  const arr = str.split(',');
 
  let degree = parseFloat(arr[0]);
  let minutes = parseFloat(arr[1]);
 
  if (isNaN(degree) || isNaN(minutes)) return null;
 
  let dd;
 
  if (degree < 0 || hemiNegative) {
    dd = -(Math.abs(degree) + minutes / 60);
  } else {
    dd = degree + minutes / 60;
  }
 
  return dd;
}

// export function toChartCord(v) {
// 	var spl, cd, cm, neg = false;
// 	spl = v.length - 4;
// 	v = v.toString();
// 	cd = v.substr(0, spl);
// 	if (cd == "-" || cd == "" || cd == undefined) { cd = 0; }
// 	if (eval(cd) < 0) { cd = -cd; neg = true; }
// 	cm = v.substr(spl, 4);
// 	spl = (neg ? "-" : "") + (v = eval(cd == "" ? 0 : cd) + eval((cm / 6000).toString().substr(0, 6)));
// 	return eval(spl);
// }

export function toChartCord(v) {
  let spl, cd, cm, neg = false;
  v = v.toString();
  spl = v.length - 4;
  cd = v.substr(0, spl);
  if (cd === "-" || cd === "" || cd === undefined) {
    cd = 0;
  }
  if (parseFloat(cd) < 0) {
    cd = -parseFloat(cd);
    neg = true;
  }
  cm = v.substr(spl, 4);
  spl = (neg ? "-" : "") + (parseFloat(cd) + parseFloat(cm) / 6000).toFixed(6);
  return parseFloat(spl);
}
 

// 🌍 Arc & Geodesy Utility Functions
 
const EarthRadiusMeters = 6378137.0; // WGS84 Earth radius in meters
const NM_TO_METERS = 1852; // 1 Nautical Mile = 1852 meters
 
// --- Helper functions ---
const toRad = (deg) => (deg * Math.PI) / 180;
const toDeg = (rad) => (rad * 180) / Math.PI;
 
/**
 * Calculates destination coordinates given a start point, bearing, and distance.
 */
const destinationPoint = (latLng, brng, dist) => {
  const R = EarthRadiusMeters;
  const lat1 = toRad(latLng.lat);
  const lon1 = toRad(latLng.lng);
  const brngRad = toRad(brng);
 
  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(dist / R) +
      Math.cos(lat1) * Math.sin(dist / R) * Math.cos(brngRad)
  );
 
  const lon2 =
    lon1 +
    Math.atan2(
      Math.sin(brngRad) * Math.sin(dist / R) * Math.cos(lat1),
      Math.cos(dist / R) - Math.sin(lat1) * Math.sin(lat2)
    );
 
  return { lat: toDeg(lat2), lng: toDeg(lon2) };
};
 
/**
 * Calculates initial bearing between two coordinates.
 */
export const bearing = (fromLatLng, toLatLng) => {
  const lat1 = toRad(fromLatLng.lat);
  const lon1 = toRad(fromLatLng.lng);
  const lat2 = toRad(toLatLng.lat);
  const lon2 = toRad(toLatLng.lng);
 
  const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
 
  return (toDeg(Math.atan2(y, x)) + 360) % 360;
};
 
/**
 * Draws an arc between two bearings at a given radius.
 */
export const drawArc = (center, initialBearing, finalBearing, radiusMeters) => {
  const points = 60; // smoother arc
  const extp = [];
 
  if (initialBearing > finalBearing) finalBearing += 360;
  const deltaBearing = (finalBearing - initialBearing) / points;
 
  for (let i = 0; i <= points; i++) {
    const brng = initialBearing + i * deltaBearing;
    extp.push(destinationPoint(center, brng, radiusMeters));
  }
 
  return extp;
};
 
/**
 * Calculates great-circle distance between two points (Haversine formula).
 */
export const distanceFrom = (fromLatLng, toLatLng) => {
  const lat1 = toRad(fromLatLng.lat);
  const lon1 = toRad(fromLatLng.lng);
  const lat2 = toRad(toLatLng.lat);
  const lon2 = toRad(toLatLng.lng);
 
  const dLat = lat2 - lat1;
  const dLon = lon2 - lon1;
 
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
 
  return 2 * EarthRadiusMeters * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
 


  /*-------------------
---------------------
create a global variable that will point to the tooltip in the DOM
---------------------
--------------------*/
var tipObj = null;
//offset along x and y in px
var offset = {
	x: 20,
	y: 20
};

export function injectTooltip(event, data) {
	if (!tipObj && event) {
		//create the tooltip object

		tipObj = document.createElement("div");
		tipObj.style.position = 'fixed';
		tipObj.style.background = "white";
		tipObj.style.borderRadius = "5px";
		tipObj.style.padding = "5px";
		tipObj.style.fontFamily = "Arial,Helvetica";
		tipObj.style.textAlign = "left";
		tipObj.innerHTML = data;
		//position it

		tipObj.style.top = event.domEvent.clientY + window.scrollY + offset.y + "px";
		tipObj.style.left = event.domEvent.clientX + window.scrollX + offset.x + "px";
		//add it to the body
		document.body.appendChild(tipObj);
	}
}

export function moveTooltip(event) {
	if (tipObj && event) {
		//position it

		tipObj.style.top = event.domEvent.clientY + window.scrollY + offset.y + "px";
		tipObj.style.left = event.domEvent.clientX + window.scrollX + offset.x + "px";
	}
}

export function deleteTooltip(event) {
	if (tipObj) {
		//delete the tooltip if it exists in the DOM
		document.body.removeChild(tipObj);
		tipObj = null;
	}
}

// Chart info functions

export function format(str, dir) {
	var minus = 0;
	let num = parseFloat(str);
    if (num < 0) {
        str = -str;
        minus = 1;
    }
	if (dir == 1) { if (minus) str += "S"; else str += "N"; }
	if (dir == 2) { if (minus) str += "W"; else str += "E"; }

	let len = str.length;
	let split = len - 5;
	return str.substr(0, split) + "&ordm; " + str.substr(split, 2) + "'." + str.substr(split + 2, 3);
}

export const decodeHtml = (html) => {
	const txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
  };

  export const sanitizeInput = (input) => {
	// Create a new div element
	const div = document.createElement('div');
	
	// Set the input as the innerHTML of the div
	div.innerHTML = input;
  
	// Use the textContent property to get only the text content, stripping out any HTML tags
	const textContent = div.textContent || div.innerText || '';
  
	return textContent;
  };

  export function formatDate(dateString) {
	// Parse the date string into a Date object
	const date = new Date(dateString);
  
	// Extract the day, month, and year
	const day = String(date.getDate()).padStart(2, '0'); // Ensure day is two digits
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
	const year = date.getFullYear();
  
	// Format the date as dd-mm-yyyy
	return `${day}-${month}-${year}`;
  }